import { Component } from 'utils/jsx'
import { writable } from 'utils/state'

export default class FileDropper extends Component {
  beforeRender () {
    this.handleDragStart = this.handleDragStart.bind(this)
    this.handleDragEnd = this.handleDragEnd.bind(this)
    this.handleDrop = this.handleDrop.bind(this)

    this.state = {
      files: writable([]),
      isDraggedOver: writable(false)
    }
  }

  template () {
    return (
      <div class='file-dropper' store-class-is-dragged-over={this.state.isDraggedOver}>
        <i class='fa fa-plus' />
      </div>
    )
  }

  afterMount (props) {
    document.body.addEventListener('dragover', this.handleDragStart)
    document.body.addEventListener('dragenter', this.handleDragStart)
    document.body.addEventListener('dragleave', this.handleDragEnd)
    document.body.addEventListener('dragend', this.handleDragEnd)
    document.body.addEventListener('drop', this.handleDrop)

    if (props['event-change']) this.state.files.subscribe(props['event-change'])
  }

  get isVisible () {
    // SEE note on https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    return this.base.offsetParent !== null
  }

  handleDragStart (e) {
    if (!this.isVisible) return
    if (!e.dataTransfer.types.includes('Files')) return

    e.preventDefault()
    e.stopPropagation()

    this.state.isDraggedOver.set(true)
  }

  handleDrop (e) {
    if (!this.isVisible) return
    if (!e.dataTransfer.types.includes('Files')) return

    this.state.files.set(Array.from(e.dataTransfer.files))
    this.handleDragEnd(e)
  }

  handleDragEnd (e) {
    if (!this.isVisible) return
    if (!e.dataTransfer.types.includes('Files')) return

    e.preventDefault()
    e.stopPropagation()

    this.state.isDraggedOver.set(false)
  }

  beforeDestroy () {
    document.body.removeEventListener('dragover', this.handleDragStart)
    document.body.removeEventListener('dragenter', this.handleDragStart)
    document.body.removeEventListener('dragleave', this.handleDragEnd)
    document.body.removeEventListener('dragend', this.handleDragEnd)
    document.body.removeEventListener('drop', this.drop)
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/FileDropper.js